// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/mainIndex'
import Vuetify from 'vuetify'
import firebase from 'firebase'
import {config} from './firebase/init'

Vue.use(Vuetify)

// index.js or main.js
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

Vue.config.productionTip = false

/* eslint-disable no-new */

let app = null;
const firebaseApp = firebase.initializeApp(config);

// wait for firebase auth to init before creating the app
firebase.auth().onAuthStateChanged(() => {
    if (!app) {
        app = new Vue({
            el: '#app',
            router,
            components: {App},
            template: '<App/>'
        })
    }
})

var db = firebaseApp.firestore();
var storage = firebase.storage();
var messaging = firebase.messaging();
db.settings({ timestampsInSnapshots: true });

export {
    db, storage, messaging
}



// WEBPACK FOOTER //
// ./src/main.js